import { css } from 'lit';

export default css`
  .recognition-buttons {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  amityeko-chip {
    --amityeko-color-gray-9: rgba(255, 255, 255, 0.2);
    --amityeko-color-gray-1: var(--amityeko-color-font-light);
    --amityeko-color-gray-8: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 0px 2px rgba(40, 41, 61, 0.12), 0px 2px 4px rgba(96, 97, 112, 0.16);
  }

  amityeko-button {
    --amityeko-color-primary-6: rgba(255, 255, 255, 0.2);
    --amityeko-color-primary-7: rgba(255, 255, 255, 0.3);
    --amityeko-circle-button-size: 40px;
  }
`;
